'use client';

import { useEffect } from 'react';
import Button from '@/components/shared/Button';

type ErrorComponentProps = {
  error: Error & { digest?: string };
  reset: () => void;
};

export const ErrorComponent = ({ error, reset }: ErrorComponentProps) => {
  useEffect(() => {
    console.error('Error:', error);
  }, [error]);

  return (
    <div className="flex h-[calc(100vh_-_120px)] w-full flex-col items-center justify-center gap-2 px-4 xl:h-[calc(100vh_-_128px)]">
      <div className="mt-8 flex max-w-screen-sm flex-col items-center gap-4 text-center md:mx-0 md:mt-0">
        <h1 className="w-fit font-publico text-2xl font-bold leading-[40px] text-blue-400 md:text-[32px]">
          Ops, encontramos um problema!
        </h1>
        <p className="text-base text-grey-700 md:text-xl">
          Ocorreu um erro e não conseguimos prosseguir com a ação. <br />
          Por favor, tente novamente mais tarde.
        </p>

        <Button
          variant="primary"
          className="mt-5 w-fit"
          onClick={() => reset()}
          aria-label="Atualizar Novamente"
        >
          Atualizar Novamente
        </Button>
      </div>
    </div>
  );
};
